<template>
  <div id="family">
    <topnav typeName vuePage="#family" title="家族说明" back="1" closeweb="1"></topnav>
    <div class="main">
      <p class="p1">1.家族是什么？</p>
      <div class="text_div">
        家族是由家族长创建的团体，其他用户可以通过申请加入，在家族里用户可以进行各种有趣的玩法和互动，
        并获得稀缺特权，享受尊贵体验！
      </div>
      <p class="p1">2.家族的玩法？</p>
      <div class="play_text">
        <p>【一键召唤家族】</p>
        <p>所有成员可一键召集，来支持家族的主播直播。</p>
      </div>
      <!-- <div class="play_text">
        <p>【家族登场动画】</p>
        <p>
          家族聊天室内发起一个召集令后，第一个响应后的5分钟内，进入直播间的人数达到5人，触发家族登场动画，
          彰显奢华排面。
        </p>
      </div> -->
      <div class="play_text">
        <p>【专属的家族聊天室】</p>
        <p>享受只有家族成员可进入的聊天室，在聊天室里畅所欲言。</p>
      </div>
      <div class="play_text">
        <p>【独有的家族动态圈】</p>
        <p>在家族主页里可查看家族动态圈，这是专属本家族的动态频道，使家族成员可以更加亲密的互动。</p>
      </div>
      <div class="play_text">【更多神秘家族活动，敬请期待~~】</div>

      <p class="p1">3.家族等级</p>
      <div class="table">
        <div class="top_text flex-box">
          <div>家族等级</div>
          <div>升级条件</div>
          <div>等级特权</div>
        </div>
        <div class="center_box flex-box" v-for="(n,i) in familyLevel" :key="i">
          <!-- 左 -->
          <div class="l_box">
            <div class="top_img">
              <img class="imgBlock noevents-img" :src="n.image" />
            </div>
            <div class="bot_img">
              <img class="imgBlock noevents-img" :src="n.mp_image" />
            </div>
          </div>
          <!-- 中 -->
          <div class="c_box flex-box">
            <p>LV.{{n.level}}</p>
            <p v-if="n.level == 1">初始等级</p>
            <p v-else>周荣誉值≥{{n.upgrade_condition/10000}}万</p>
          </div>
          <!-- 右 -->
          <div class="r_box flex-box">
            <p>可容纳{{n.join_num_limit}}名成员</p>
            <p>可喜欢{{n.like_anchores_num}}名主播</p>
            <p>可设置{{n.in_charge_num}}名管理员</p>
          </div>
        </div>
      </div>
      <p class="bot_text">
        注：连续两周未完成当前家族等级所需荣誉值的70%，
        家族将会降级哦。
      </p>
    </div>
  </div>
</template>







<script>
import topnav from "../index/top_nav";
export default {
  name: "family",
  components: {
    topnav,
  },
  data() {
    return {
      familyLevel: [], //家族勋章信息的数组
    };
  },
  mounted() {
    this.getfamilyLevel();
  },
  methods: {
    getfamilyLevel() {
      let _this = this;
      this.$jsonp(this.$apis("family_level"), {}, (res) => {
        _this.familyLevel = res.data.data;
      });
    },
  },
};
</script>









<style>
#family .c-bk {
  width: 100%;
  background: #fff;
}
</style>

<style scoped>
#family {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
}
.main {
  padding: 16px;
}
.main .p1 {
  font-size: 17px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 20px;
}
.text_div {
  color: #333333;
  font-size: 14px;
  margin-bottom: 20px;
  line-height: 1.5;
}
.play_text {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 22px;
}
.play_text p:nth-child(2) {
  padding-left: 4px;
}
.table {
  width: 100%;
  border-top: 1px solid #70421e;
  border-left: 1px solid #70421e;
}
.top_text,
.center_box {
  width: 100%;
}
.table .top_text div {
  background-color: #e3bd7f;
  width: 33.33%;
  height: 34px;
  text-align: center;
  line-height: 34px;
  border-right: 1px solid #70421e;
  border-bottom: 1px solid #70421e;
  color: #70421e;
  font-size: 14px;
}
.center_box > div {
  width: 33.33%;
  text-align: center;
  border-right: 1px solid #70421e;
  border-bottom: 1px solid #70421e;
}
.l_box {
  padding: 6px 0 8px;
}
.l_box div {
  width: 100%;
}
.l_box .top_img img {
  margin: auto;
  width: 90%;
}
.bot_img {
  margin-top: -12px;
}
.l_box .bot_img img {
  width: 80%;
  margin: auto;
}
.c_box,
.r_box {
  flex-direction: column;
  justify-content: center;
  padding: 8px;
}
.c_box p:nth-child(1) {
  color: #333;
  font-size: 14px;
}
.c_box p:nth-child(2) {
  color: #666;
  font-size: 13px;
  margin-top: 6px;
}
.r_box p {
  color: #666;
  font-size: 13px;
  margin-bottom: 6px;
  padding: 0 16px;
}
.bot_text {
  color: #666;
  font-size: 14px;
  margin-top: 12px;
  margin-bottom: 20px;
}
</style>

